import { create } from 'zustand';
import ApiService from '../services/ApiService';

const useBillingStore = create((set, get) => ({
  billingInfo: null,
  subscription: null,
  loading: false,
  error: null,

  fetchBillingInfo: async () => {
    set({ loading: true, error: null });
    try {
      const data = await ApiService.getBillingUsage();
      set({ billingInfo: data, loading: false });
    } catch (error) {
      console.error('Error fetching billing info:', error);
      set({ error, loading: false });
    }
  },

  fetchSubscriptionDetails: async (force = false) => {
    // If subscription details are already in the store, don't fetch them again unless forced.
    if (get().subscription && !force) {
      return;
    }

    set({ loading: true, error: null });
    try {
      const data = await ApiService.getSubscriptionDetails();
      set({ subscription: data?.subscription, loading: false });
    } catch (error) {
      console.error('Error fetching subscription details:', error);
      set({ error, loading: false, subscription: null });
    }
  },

  clearBillingInfo: () => {
    set({ billingInfo: null, subscription: null, error: null });
  },
}));

export default useBillingStore;
